/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback, useRef } from "react"
import useAnalytics from 'hooks/useAnalytics'
import isClient from "utils/isClient"
import scrollTo from "utils/scrollTo"
import { track } from "services/redline"

export default function useCamera({
  facing,
  setShouldOpenCamera
} = {}) {
  const [isEnvironmentCamera, setIsEnvironmentCamera] = useState(facing === "environment")
  const [stream, setStream] = useState(null)
  const [showTakePictureButton, setShowTakePictureButton] = useState(false)
  const videoRef = useRef(null)

  const timeToShowTakePictureButton = 600

  useEffect(() => {
    if (!stream) {
      handleCamera()
    }

    navigator?.permissions?.query({ name: 'camera' })
      .then((permissionStatus) => {
        permissionStatus.onchange = () => {

          if (permissionStatus.state === 'denied') {
            console.log('[ CAMERA ] Permission was denied. Camera should be closed.')
            trackUserPermissions('permissionsQueryUndefined')
            _closeStreamTracks()
            setShouldOpenCamera(false)
          }
        }
    })
  }, [])

  const handleReopenCamera = () => {
    _closeStreamTracks()
    _openStreamTracks()
  }

  const handleCamera = () => {
    if (stream) {
      _closeStreamTracks()

      setShouldOpenCamera(false)
    } else {
      _openStreamTracks()
    }
  }

  function _openStreamTracks() {
    const constraints = {
      video: {
        facingMode: isEnvironmentCamera ? "environment"  : "user",
      },
    }
    console.log('stream', stream)
    navigator.mediaDevices.getUserMedia(constraints)
      .then((mediaStream) => {
        setStream(mediaStream)

        if (videoRef.current) videoRef.current.srcObject = mediaStream

        trackUserPermissions()

        setTimeout(() => setShowTakePictureButton(true), timeToShowTakePictureButton)

      })
      .catch((error) => {
        console.error(error)
      })
  }

	function _closeStreamTracks() {
		console.log('[ CAMERA ] The streamTrack will be closed', stream)
		const tracks = stream?.getTracks() || []
		tracks?.forEach((track) => {
		  track?.stop()

		  setShowTakePictureButton(false)
		})

    setStream(null)
	}

  function trackUserPermissions(cameraPermission = "granted") {
    const userAgent = navigator?.userAgent

    track('mediaStatusTracked', {
      userAgent,
      cameraPermission}
    )

  }


  return {
    videoRef,
    stream,
    isEnvironmentCamera,
    showTakePictureButton,
    handleCamera,
    _closeStreamTracks,
    handleReopenCamera
  }
}
